import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchOfferTags } from 'actions/OfferActions'
import useQueryParams from 'hooks/useQueryParams'
import { buildOfferTagsCacheKey } from 'lib/experiences/experienceUtils'

interface UseOfferTagsResult {
  tags: Array<{ id: string; name: string }>
  fetching: boolean
}

function useOfferTags(offerId: string | undefined): UseOfferTagsResult {
  const dispatch = useAppDispatch()
  const queryParams = useQueryParams()

  const checkInDate = queryParams.get('checkIn') ?? undefined
  const checkOutDate = queryParams.get('checkOut') ?? undefined

  const cacheKey = useMemo(() => {
    if (!offerId) return undefined
    return buildOfferTagsCacheKey(offerId, checkInDate, checkOutDate)
  }, [offerId, checkInDate, checkOutDate])

  const tagData = useAppSelector(state => {
    if (!cacheKey) {
      return undefined
    }
    return state.offer.offerTags?.[cacheKey]
  })

  useEffect(() => {
    if (!offerId) {
      return
    }

    dispatch(fetchOfferTags(offerId, { travelStartDate: checkInDate, travelEndDate: checkOutDate, travelDateOverlap: true }))
  }, [dispatch, offerId, checkInDate, checkOutDate])

  return {
    tags: tagData?.tags ?? [],
    fetching: tagData?.fetching ?? false,
  }
}

export default useOfferTags
